// @flow
import TextFieldView, { textFieldViewTester } from './TextFieldView';
import BooleanFieldView, { booleanFieldViewTester } from './BooleanFieldView';
import PreviewTextInputView, {
    previewTextInputViewTester
} from './PreviewTextInputView';

export const viewControlRenderers = [
    {
        renderer: TextFieldView,
        tester: textFieldViewTester
    },
    {
        renderer: BooleanFieldView,
        tester: booleanFieldViewTester
    },
    {
        renderer: PreviewTextInputView,
        tester: previewTextInputViewTester
    }
];
